import { BaseAction, DataAction } from '../CustomTypes'
import { RedirectBundle } from '../actions/RedirectAction'
import { REDIRECT, REDIRECT_DONE } from '../actions/RedirectAction'

export interface RedirectState {
    path: string | undefined
}

export const redirectStateInitial: RedirectState = {
    path: undefined
}

export function redirectReducer (
  state: RedirectState = redirectStateInitial, // eslint-disable-line @typescript-eslint/default-param-last
  action: BaseAction): RedirectState {
  switch (action.type) {
    case REDIRECT:
        const a = action as DataAction<RedirectBundle>
        return {path: a.data.path}
    case REDIRECT_DONE:
        return {path: undefined};
    default:
      return state
  }
}
